<template>
  <div class="FormLaptopsSettings">
    <FormSect :title="$t('weights')">
      <Row class="weights">
        <Column
          v-for="(value, key) in weights"
          :key="key"
          :md="3">
          <Field
            :label="$t(key)"
            :options="weightOptions"
            type="select"
            :value="value"
            @update:value="setWeight(key, $event)" />
        </Column>
      </Row>
    </FormSect>
    <FormSect :title="$t('minimalScores')">
      <Row class="minimalScores">
        <Column
          v-for="(value, key) in minimalScores"
          :key="key"
          :md="3">
          <Field
            :label="$t(key)"
            type="number"
            :value="value"
            @update:value="setMinimalScores(key, $event)" />
        </Column>
      </Row>
    </FormSect>
    <FormLaptopBuckets
      v-if="isBucketView"
      :bucketsPrices="bucketsPrices"
      @refresh="$emit('refresh')"
      @update:bucketsPrices="$emit('update:bucketsPrices', $event)" />
  </div>
</template>

<script>
import FormLaptopBuckets from './FormLaptopBuckets'
import { assoc } from 'rambda'
import { getters } from '@utils'

export default {
  components: {
    FormLaptopBuckets,
  },
  props: {
    bucketsPrices: Array,
    isBucketView: Boolean,
    weights: Object,
    minimalScores: Object,
  },
  computed: getters('weightOptions'),
  methods: {
    setWeight(key, value) {
      this.$emit('update:weights', assoc(key, value, this.weights))
    },
    setMinimalScores(key, value) {
      this.$emit('update:minimalScores', assoc(key, value, this.minimalScores))
    },
  },
}
</script>

<style lang="scss">
.FormLaptopsSettings {
  margin-bottom: 1rem;
}
</style>

<i18n>
{
  "en": {
    "battery": "Battery",
    "bonus": "Bonus",
    "cpu": "Processor",
    "memory": "Memory",
    "ports": "Ports",
    "resolution": "Resolution",
    "screen": "Screen",
    "storageNvme": "Storage (NVMe)",
    "storageSpace": "Storage (space)",
    "storageSsd": "Storage (SSD)",
    "graphics": "Graphics",
    "weight": "Weight",
    "weights": "Weights",
    "minimalScores": "Minimum Scores",
    "batteryScore": "Battery Score",
    "bonusScore": "Bonus Score",
    "computingScore": "Computing Score",
    "graphicsScore": "Graphics Score",
    "memoryScore": "Memory Score",
    "keyboardScore": "Keyboard Score",
    "portsScore": "Ports Score",
    "reviewScore": "Review Score",
    "screenQualityScore": "Screen Quality Score",
    "screenScore": "Screen Score",
    "storageScore": "Storage Score",
    "weightScore": "Weight Score"
  }
}
</i18n>
